<div class="card-link-wrap relative">
  <div class="pr-[100px]">
    @if (title) {
      <h3 class="text-primary mb-1 text-lg font-medium">{{ title }}</h3>
    }
    @if (subtitle) {
      <div class="text-secondary text-md mb-8">{{ subtitle }}</div>
    }
  </div>

  <div class="absolute bottom-0 right-0 overflow-hidden rounded-[1rem]">
    @if (imageSrc) {
      <img [src]="imageSrc" alt="{{ title }}" />
    }
  </div>
</div>
